export interface FeatureFlag {
  brand: {
    name: string
    website: string
    supportEmail: string
  }
  customerCode: string
  locale: {
    default: string
  }
  currency: {
    default: string
  }
  activeSearchModes: {
    destination: boolean
    attributes: boolean
    events: boolean
    visa: boolean
  }
  activeResults: {
    flight: boolean
    hotel: boolean
    car: boolean
    aircraft: boolean
  }
  paymentProvider: {
    active: 'jcc' | 'paypal' | 'sslcommerz'
  }
  userResidency: {
    default: string | undefined
  }
  localization: {
    sex: Record<string, string>
  }
  showTermsCheckboxInPayment: {
    enabled: boolean
  }
  paymentMethods: {
    enabled: boolean
    methods: {
      card: boolean
      wallet: boolean
    }
  }
}

const featureFlag: FeatureFlag = {
  brand: {
    name: 'Budgetfly',
    website: 'Budgetfly.com',
    supportEmail: 'support@budgetfly.com',
  },
  customerCode: import.meta.env.VITE_CUSTOMER_CODE,
  locale: {
    default: 'en',
  },
  currency: {
    default: 'EUR',
  },
  activeSearchModes: {
    destination: true,
    attributes: true,
    events: false,
    visa: false,
  },
  activeResults: {
    flight: true,
    hotel: true,
    car: false,
    aircraft: false,
  },
  paymentProvider: {
    active: 'jcc',
  },
  userResidency: {
    default: 'CY',
  },
  localization: {
    sex: {
      en: 'Gender',
      ar: 'الجنس',
      bn: 'লিঙ্গ',
      de: 'Geschlecht',
      el: 'φύλο',
      es: 'Sexo',
      fr: 'Sexe',
      it: 'Sesso',
      pt: 'Sexo',
      sr: 'Пол',
    },
  },
  showTermsCheckboxInPayment: {
    enabled: false,
  },
  paymentMethods: {
    enabled: true,
    methods: {
      card: true,
      wallet: true,
    },
  },
}

export default featureFlag
